<template>
  <div class="main-container">
    <div class="select-tab-wrap">
      <Classify
        class="classify"
        :items="[
          {
            id: 'classify',
            name: $t('common.classify'),
            value: { item: classify, child: sub_classify },
            children: classifyList,
          },
        ]"
        @change="onClassifyChange"
      ></Classify>
    </div>
    <div class="main clearfix">
      <div class="left f-left">
        <BlockTabs
          class="library-tabs"
          :items="tabs"
          currentClass="bold5"
          isNew
          @changeTab="changeTab"
        ></BlockTabs>
        <div class="list">
          <router-link
            :to="{ name: 'LibraryDetail', params: { id: item.id } }"
            v-for="item in list"
            :key="item.id"
          >
            <div
              class="item"
              :class="{
                word: item.file_ext == 'docx' || item.file_ext == 'doc',
                excel: item.file_ext == 'xlsx' || item.file_ext == 'xls',
                pdf: item.file_ext == 'pdf',
              }"
            >
              <div class="name-wrap">
                <div class="name">{{ item.name }}</div>
                <div class="browse">
                  {{ item.browse_num + item.browse_base }}人已观看
                </div>
              </div>
              <div class="instruction">{{ item.instruction }}</div>
              <img
                class="icon"
                src="../../images/library/doc@2x.png"
                v-if="item.file_ext == 'docx' || item.file_ext == 'doc'"
              />
              <img
                class="icon"
                src="../../images/library/xls@2x.png"
                v-else-if="item.file_ext == 'xlsx' || item.file_ext == 'xls'"
              />
              <img
                class="icon"
                src="../../images/library/pdf@2x.png"
                v-else-if="item.file_ext == 'pdf'"
              />
            </div>
          </router-link>
          <EmptyNew v-if="list.length == 0" class="empty" title="暂无文库！" />
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="limit"
            layout="prev, pager, next, total, jumper"
            :total="total"
            v-if="list.length > 0"
          ></el-pagination>
        </div>
      </div>
      <div class="right f-right">
        <div class="header">
          <img src="../../images/library/lib@2x.png" />
          <span>文库推荐</span>
        </div>
        <div class="recommend" v-for="item in recommends" :key="item.id">
          <router-link :to="{ name: 'LibraryDetail', params: { id: item.id } }">
            <img
              class="icon"
              src="../../images/library/doc@2x.png"
              v-if="item.file_ext == 'docx' || item.file_ext == 'doc'"
            />
            <img
              class="icon"
              src="../../images/library/xls@2x.png"
              v-else-if="item.file_ext == 'xlsx' || item.file_ext == 'xls'"
            />
            <img
              class="icon"
              src="../../images/library/pdf@2x.png"
              v-else-if="item.file_ext == 'pdf'"
            />
            <span>{{ item.name }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Classify from "../../components/Classify.vue";
import EmptyNew from "@/components/EmptyNew.vue";

export default {
  name: "LibraryList",
  components: {
    Classify,
    EmptyNew,
  },
  data() {
    return {
      classify: 0,
      sub_classify: 0,
      classifyList: [],
      list: [],
      page: 1,
      limit: 6,
      total: 0,
      current: "id",
      tabs: [
        { id: "id", name: "最新" },
        { id: "hot", name: "最热" },
      ],
      recommends: [],
    };
  },
  async created() {
    await this.getClassify();
    await this.getList();
    await this.getRecommend();
  },
  methods: {
    async getClassify() {
      this.classifyList = await this.$http.get("/api/app/library/classify");
    },
    async getList() {
      let data = await this.$http.get(
        "/api/app/library/list/" + (this.sub_classify || this.classify),
        {
          page: this.page,
          limit: this.limit,
          order: this.current,
        },
      );
      this.total = data.total;
      this.list = data.data;
    },
    async onClassifyChange({ value }) {
      this.classify = value.item;
      this.sub_classify = value.child;
      this.page = 1;
      await this.getList();
    },
    async changeTab(item) {
      this.current = item.id;
      this.page = 1;
      await this.getList();
    },
    async handleCurrentChange(page) {
      this.page = page;
      await this.getList();
    },
    async getRecommend() {
      this.recommends = await this.$http.get("/api/app/library/random");
    },
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  padding-bottom: 50px;
}
.select-tab-wrap {
  margin: 30px 0;
}
.main {
  .tabs {
    background: rgba(247, 248, 250, 1);
  }
  .tab-item span {
    border-right: none;
  }
  .el-tabs-custom {
    padding-top: 12px;
  }
  .left {
    width: 830px;
    background-color: white;
    box-sizing: border-box;
    border-radius: 15px;
    /deep/ {
      .el-pagination {
        margin-bottom: 0;
      }
    }
    .list {
      padding: 12px 24px 24px 37px;
    }
    .item {
      height: 130px;
      background-color: rgba(255, 255, 255, 1);
      box-shadow: 0px 6px 20px 0px $primary-color-04,
        0px 13px 33px 0px rgba(0, 0, 0, 0.04);
      border-radius: 20px;
      margin-bottom: 26px;
      padding: 25px 24px 24px 36px;
      box-sizing: border-box;
      position: relative;
      background-position: right top;
      background-repeat: no-repeat;
      background-size: 137px 118px;
      &.excel {
        background-image: url(../../images/library/back-excel@3x.png);
      }
      &.word {
        background-image: url(../../images/library/back-word@3x.png);
      }
      &.pdf {
        background-image: url(../../images/library/back-pdf@3x.png);
      }
      .name-wrap {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
      }
      .name {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(32, 36, 42, 1);
        line-height: 19px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex-grow: 1;
        &:hover {
          color: $primary-color;
        }
      }
      .instruction {
        height: 46px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: normal;
        color: rgba(140, 140, 140, 1);
        line-height: 23px;
        letter-spacing: 1px;
        overflow: hidden;
      }
      .browse {
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(140, 140, 140, 1);
        line-height: 12px;
        letter-spacing: 1px;
        text-align: right;
        img {
          width: 14px;
          margin-right: 6px;
        }
      }
      .icon {
        position: absolute;
        width: 34px;
        top: 25px;
        left: -13px;
      }
    }
  }
  .right {
    padding: 15px 20px 20px 20px;
    background-color: white;
    width: 342px;
    box-sizing: border-box;
    border-radius: 10px;
    .header {
      padding-bottom: 3px;
      img {
        width: 14px;
        margin-right: 7px;
        vertical-align: middle;
      }
      span {
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333;
        line-height: 22px;
        vertical-align: middle;
      }
    }
    .recommend {
      padding-top: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      img {
        width: 12px;
        margin-right: 9px;
        vertical-align: middle;
      }
      span {
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(32, 36, 42, 1);
        line-height: 22px;
        vertical-align: middle;
        &:hover {
          color: $primary-color;
        }
      }
    }
  }
}
.library-tabs {
  /deep/ {
    .tab-item {
      width: auto !important;
      margin-right: 0 !important;
      &:first-child {
        margin: 0 40px 0 24px !important;
      }
    }
  }
}
</style>
<style lang="scss">
html,
body {
  background: rgba(247, 248, 250, 1);
}
</style>
